import React from "react";
import "../css/footer.css";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import logo from "../images/logo.png";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const bookForm = (role) => {
    navigate(`/bookForm?role=${role}`);
  };
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo Column */}
        <div className="footer-column">
          <img src={logo} alt="EnergyX Africa Logo" className="footer-logo" />
        </div>

        {/* Links Column */}
        <div className="footer-column">
          <h3 className="footer-title">Register here</h3>
          <ul className="footer-links">
            <li>
              <a
                onClick={() => bookForm("exhibitor")}
                style={{ cursor: "pointer" }}
              >
                Exhibitors
              </a>
            </li>
            <li>
              <a
                onClick={() => bookForm("sponsor")}
                style={{ cursor: "pointer" }}
              >
                Sponsorship
              </a>
            </li>
            <li>
              <a
                onClick={() => bookForm("delegate")}
                style={{ cursor: "pointer" }}
              >
                Delegate
              </a>
            </li>
          </ul>
        </div>

        {/* Programme Column */}
        <div className="footer-column">
          <h3 className="footer-title">Conference</h3>
          <ul className="footer-links">
            <li>
              {" "}
              <Link to="/programme">Programme</Link> <br />
              <Link to="/speakers">Call for Speakers</Link> <br />
              <Link to="/xp">EnergyX Africa XP</Link>
            </li>
          </ul>
        </div>

        {/* Social Media Column */}
        <div className="footer-column">
          <h3 className="footer-title">Social Media</h3>
          <div className="social-links">
            <a
              href="https://www.facebook.com/ExperienceEnergyxAfrica/"
              aria-label="Facebook"
              className="social-link"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://x.com/EnergyxAfrica"
              aria-label="Twitter"
              className="social-link"
            >
              <FaTwitter />
            </a>
            <a
              href="https://www.instagram.com/energyx.africa/"
              aria-label="Instagram"
              className="social-link"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/company/experience-energyx-africa/?originalSubdomain=za"
              aria-label="LinkedIn"
              className="social-link"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://www.youtube.com/@EnergyXAfrica/featured"
              aria-label="LinkedIn"
              className="social-link"
            >
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} EnergyX Africa. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
